module.exports = __webpack_public_path__ + "media/application/images/2024/title-750-443aa3cb9d0fef7ce1f550c4d24d99c0.png";